import * as React from "react";
import {none, Option} from "ts-option";
import Modal from "../../../../ui/modal/Modal";
import SelectMerchant from "./SelectMerchant";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {api} from "../../../../../api/api";
import Toast from "../../../../helper/Toast";
import {notifyBugsnagAndShowToast} from "../../../../../utils/Utils";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import Merchant from "../../../../../model/merchant/Merchant";

interface Props {
	/**
	 * On close modal callback.
	 */
	onClose: () => void;
	/**
	 * Placeholder.
	 */
	placeholder: string;
}

interface IState {
	/**
	 * Indicates if file is being downloaded
	 */
	isDownloading: boolean;
	/**
	 * Selected merchant
	 */
	merchant: Option<Merchant>;
}

export default class DownloadAssetMaterialsModal extends React.Component<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isDownloading: false, merchant: none};
	}

	render() {
		return (
			<Modal customClass={"c-download-asset-materials-modal"}
				   onCloseClicked={this.props.onClose}
				   title={"Download asset materials"}
				   autoWidth={true}
				   oveflowUnset={true}>
				<label>Merchant</label>
				<SelectMerchant placeholder={this.props.placeholder}
								selectedId={this.state.merchant.map(m => m.id)}
								onChanged={this.onChange}/>
				<div className={"buttons"}>
					<ButtonTertiary label={"Cancel"}
									onClick={this.props.onClose}/>
					<ButtonPrimary label={"Download"}
								   onClick={this.onDownloadFile}
								   disabled={this.state.merchant.isEmpty || this.state.isDownloading}/>
				</div>
			</Modal>
		);
	}

	/**
	 * Callback on merchant changed.
	 * @param selectedMerchant
	 */
	onChange = (selectedMerchant: Option<Merchant>) => {
		this.setState({merchant: selectedMerchant})
	};

	/**
	 * Download file
	 */
	onDownloadFile = (evt: React.MouseEvent<HTMLButtonElement>) => {
		if (this.state.merchant.isDefined) {
			this.setState({isDownloading: true}, () => api.instance.merchantApi.downloadAssetMaterials(this.state.merchant.get)
				.then(() => this.setState({isDownloading: false}))
				.catch((err: any) => {
					this.setState({isDownloading: false});
					if (err && err.response && err.response.data.status == 404) {
						Toast.error("Asset materials data not found.", "Asset materials download");
					}
					else {
						notifyBugsnagAndShowToast(err, "Asset materials download");
					}
				})
			)
		}
	}
}